export class TagReadBarcodeResponse {


  /*{
   "time": 1511451719135,
   "type": "Code 128",
   "value": "AE1000000000000000367352"
   }*/

  public time: number;

  public type: string;

  public value: string;


  constructor(time: number, type: string, value: string){
    this.time = time;
    this.type = type;
    this.value = value;
  }

}



// WEBPACK FOOTER //
// ./src/models/reader-model/tagReadBarcodeResponse.ts